import { PaymentSystemType } from './payment-system-type';

export default class PaymentSystem {
    Id: number = 0;
    PaymentType: PaymentSystemType = PaymentSystemType.Payu;
    CanResendForm: boolean = false;
    IsBasePayment: boolean = false;
}